import React from 'react'

const Contact = () => {
    return (
        <div>
            {/* Create one responsive, animations on focus and active and be able to connect to MongoDB */}
            <h1>Send me an email</h1>
            <p>Here there's supposed to be a form, I will make one</p>
            <p>Everything center and if it's a grid, I'm okay with it</p>
        </div>
    )
}

export default Contact;
